<div class="parcel-item-details-outer-container">
	<div class="parcel-item-details-inner-container" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
		<div *ngIf="getAllItems()?.length === 0">{{ 'parcelItemsView.noItemsText' | translate }}</div>
		<div *ngIf="getAllItems()?.length > 0" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<div class="mat-table-wrapper">
				<div fxLayout="row wrap" fxLayoutGap="25px">
					<h3 fxLayoutAlign="left">Parcel Item Details</h3>
					<mat-form-field *ngIf="stopType=='ONDEMAND'" class="max-width-125">
						<mat-select (selectionChange)="filterItems($event?.value)" [value]="itemFilter" fxLayoutAlign="center center">
							<mat-option value="showAll">{{ 'parcelItemsView.showAllLabel' | translate }}</mat-option>
							<mat-option value="received">{{ 'parcelItemsView.receivedLabel' | translate }}</mat-option>
							<mat-option value="pickup">{{ 'parcelItemsView.pickupLabel' | translate }}</mat-option>
							<mat-option value="delivery">{{ 'parcelItemsView.deliveryLabel' | translate }}</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field *ngIf="stopType=='ROUTESTOP'">
						<mat-select (selectionChange)="filterItems($event?.value)" [value]="itemFilter" fxLayoutAlign="center center">
							<mat-option value="showAll">{{ 'parcelItemsView.showAllLabel' | translate }}</mat-option>
							<mat-option *ngFor='let a of assignmentIdNamePairs' [value]="a.id">{{ a.name ? a.name : ('parcelItemsView.unnamedStopLabel' | translate) }}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<mat-table [dataSource]="dataSource">
					<ng-container matColumnDef="parcelItem">
						<mat-header-cell *matHeaderCellDef>
							{{ 'parcelItemsView.parcelItemColumnHeader' | translate }}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								[attr.data-label]="'parcelItemsView.parcelItemColumnHeader' | translate">
							{{ element?.parcelItem?.description }}
						</mat-cell>
						<mat-footer-cell *matFooterCellDef class="padding-left-0">
							<p>{{ 'Total Parcel Items: ' + calcTotalItems() }}</p>
						</mat-footer-cell>
					</ng-container>
					<ng-container matColumnDef="quantity">
						<mat-header-cell *matHeaderCellDef>
							{{ 'parcelItemsView.quantityColumnHeader' | translate }}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								[attr.data-label]="'parcelItemsView.quantityColumnHeader' | translate">
							{{ element?.quantity }}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="barcode">
						<mat-header-cell *matHeaderCellDef>
							{{ 'parcelItemsView.barcodeColumnHeader' | translate }}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								[attr.data-label]="'parcelItemsView.barcodeColumnHeader' | translate">
							{{ element?.reference ? element?.reference : element?.barcode }}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="scannedWhen">
						<mat-header-cell *matHeaderCellDef>
							{{ 'parcelItemsView.scannedWhenColumnHeader' | translate }}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								[attr.data-label]="'parcelItemsView.scannedWhenColumnHeader' | translate">
							{{ element?.scannedWhen ? element.scannedWhen.formattedDate + ' ' + element.scannedWhen.formattedTime + ' ' + element.scannedWhen.timeZone : '' }}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="comments">
						<mat-header-cell *matHeaderCellDef>
							{{ 'parcelItemsView.commentsColumnHeader' | translate }}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								[attr.data-label]="'parcelItemsView.commentsColumnHeader' | translate">
							{{ element?.comments }}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="refrigerationType">
						<mat-header-cell *matHeaderCellDef>
							{{ 'parcelItemsView.refrigerationTypeColumnHeader' | translate }}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								[attr.data-label]="'parcelItemsView.refrigerationTypeColumnHeader' | translate">
							{{ element?.refrigerationType }}
						</mat-cell>
					</ng-container>
					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns;" [cdkDetailRowTpl]="tpl" [cdkDetailRow]="row"
							matRipple>
					</mat-row>
					<mat-footer-row *matFooterRowDef="['parcelItem']" class="bold-no-bottom-border"></mat-footer-row>
				</mat-table>
			</div>
		</div>
	</div>
</div>